import { createSignal, Show } from "solid-js"
import { useSearchParams } from "@solidjs/router"
import { createScheduledTasksController } from "./scheduled-tasks-controller"
import { ScheduledTasksView, ScheduledTasksHistoryView } from "./scheduled-tasks-view"
import "./scheduled-tasks.css"

type AutomationTab = "tasks" | "history"

export function AutomationPage() {
  const taskController = createScheduledTasksController()
  const [params] = useSearchParams()
  const [autoTab, setAutoTab] = createSignal<AutomationTab>(params.auto === "history" ? "history" : "tasks")

  return (
    <div class="scheduled-tasks-root">
      <div class="scheduled-tasks-sheet-tabs">
        <button
          class="scheduled-tasks-sheet-tab"
          classList={{ "scheduled-tasks-sheet-tab--active": autoTab() === "tasks" }}
          onClick={() => setAutoTab("tasks")}
        >
          定时任务
        </button>
        <button
          class="scheduled-tasks-sheet-tab"
          classList={{ "scheduled-tasks-sheet-tab--active": autoTab() === "history" }}
          onClick={() => setAutoTab("history")}
        >
          运行记录
        </button>
      </div>

      <Show when={autoTab() === "tasks"}>
        <ScheduledTasksView controller={taskController} />
      </Show>
      <Show when={autoTab() === "history"}>
        <ScheduledTasksHistoryView controller={taskController} />
      </Show>
    </div>
  )
}

export default AutomationPage
